import { render, staticRenderFns } from "./ComplexSlider.vue?vue&type=template&id=830c5682&"
import script from "./ComplexSlider.vue?vue&type=script&lang=js&"
export * from "./ComplexSlider.vue?vue&type=script&lang=js&"
import style0 from "./ComplexSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports